import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import TabHeader from "../../tab/TabHeader"
import FileUploadButton from "./FileUploadButton"
import NotesComponent from "../notes/NotesComponent"
import DocumentsFilters from "./DocumentsFilters"
import DocumentsDetails from "./DocumentsDetails"
import { activeCaseDocuments } from "../../../../lib/docs"
import { filesActions } from "../../../../store/files"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"

const DocumentsTab = ({ inWorkQ }) => {
    const dispatch = useDispatch()
    const [uploaded, setUploaded] = useState([])
    const activeCase = useSelector(state => state.case.activeCase)

    const deletePermission = useUserTabEditPermissionDisabled('documents_delete')
    const restorePermission = useUserTabEditPermissionDisabled('documents_restore')
    const hardDeletePermission = useUserTabEditPermissionDisabled('documents_hard_delete')


    const removeFileWithId = (id) => {
        setUploaded(prevState => prevState.filter(item => item.id !== id));
    }
  
    useEffect(() => {
        return () => {
            dispatch(filesActions.setFilterResult(null))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Documents</h2>
                <NotesComponent noteTypeId={11} inWorkQ={inWorkQ}/>
            </div>
            <div className="flex-container">
                {activeCase && activeCaseDocuments(activeCase.documents).length > 0 && <DocumentsFilters />}
                <FileUploadButton setUploaded={(data) => setUploaded(data)}/>
            </div>
            
        </TabHeader>

        <DocumentsDetails
            uploadedFile={uploaded}
            removeFileWithId={removeFileWithId}
            deletePermission={deletePermission}
            restorePermission={restorePermission}
            hardDeletePermission={hardDeletePermission}
        />
    </>
}

export default DocumentsTab